import React, { lazy, Suspense, useState } from "react";
import { Routes, Route } from "react-router-dom"; // Use react-router-dom
import { Popup } from "component/Popup";
import Loader from "component/Loader";
import { renderInfoSidebarRoutes } from "./InfoSidebarPaths";
import Sitemap from "component/Sitemap";

const Home = lazy(() => import("pages/home/components/Home"));
const LoginCard = lazy(() => import("pages/auth/login/components/Login"));
const ForgotPasswordCard = lazy(() => import("pages/auth/forgotpassword/components/ForgotPassword"));
const OTPCard = lazy(() => import("pages/auth/forgotpassword/components/OTP"));
const RegisterCard = lazy(() => import("pages/auth/register/components/Register"));
const NewPasswordCard = lazy(() => import("pages/auth/forgotpassword/components/NewPassword"));
// const Activation = lazy(() => import("pages/auth/activation/components/Activation"));

export const RouteList = () => {

  return (
    <Suspense fallback={<Loader />}>
      <Routes>
        <Route index path="/" element={<Home infoRouteName={""} />} />
        <Route path="/bit/:id" element={<Home infoRouteName={""} />} />
        <Route path="/Popup" element={<Popup />} />
        <Route path="/login" element={<LoginCard />} />
        <Route path="/forgot-password" element={<ForgotPasswordCard />} />
        <Route path="/verify-account" element={<ForgotPasswordCard />} />
        <Route path="/otp" element={<OTPCard />} />
        <Route path="/register" element={<RegisterCard />} />
        <Route path="/new-password" element={<NewPasswordCard />} />
        {/* <Route path="/activation/:uid/:token" element={<Activation />} /> */}
        {/* <Route path="/" element={<Marketinglanding />} /> */}

        {/* INFO sidebar urls with name added */}
        {renderInfoSidebarRoutes(Home)}

        {/* public urls */}
        <Route path="/sitemap" element={<Sitemap />} />

        <Route path="*" element={<p>404 Page not Found </p>}></Route>
      </Routes>
    </Suspense>
  );
};
